// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardOutlinedSvg from "@fishx/icons-svg/es/asn/DashboardOutlined";
import FishxIcon from '../components/FishxIcon';

var DashboardOutlined = function DashboardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardOutlinedSvg
  }));
};

DashboardOutlined.displayName = 'DashboardOutlined';
export default React.forwardRef(DashboardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DashboardOutlined.js
// module id = 2369
// module chunks = 0